import adminService from '../admin/index.js'

export const emergencyHelpApi = {
  getResponses(params) {
    return adminService.get('/emergency-help/responses', { params })
  },
  getStatistics() {
    return adminService.get('/emergency-help/statistics')
  }
}
